import React from 'react';

import Browser from 'browser';
import investment from 'browser/investments/yacht-apartments';

const IndexPage = () => {
  return (
    <>
      <main>
        <Browser investment={investment} />
      </main>
    </>
  );
};

export default IndexPage;
